<div class="rate-config-editor">

  <!-- Read-only banner ─────────────────────────────────────────── -->
  <div class="rce-readonly-banner" *ngIf="effectiveReadOnly">
    <mat-icon>lock</mat-icon>
    <span i18n="@@This document is read-only for your role.">This document is read-only for your role.</span>
  </div>

  <!-- Loading ─────────────────────────────────────────────────── -->
  <div class="rce-loading" *ngIf="loadState === 'LOADING'">
    <mat-progress-spinner mode="indeterminate" diameter="32"></mat-progress-spinner>
    <span i18n="@@Loading rate configuration…">Loading rate configuration…</span>
  </div>

  <ng-container *ngIf="loadState === 'LOADED'">

    <!-- Toolbar ─────────────────────────────────────────────── -->
    <div class="rce-toolbar">
      <button mat-stroked-button (click)="validateNow()">
        <mat-icon>rule</mat-icon>
        <span i18n="@@Validate">Validate</span>
      </button>
      <button mat-stroked-button (click)="format()" [disabled]="effectiveReadOnly">
        <mat-icon>format_align_left</mat-icon>
        <span i18n="@@Format">Format</span>
      </button>
      <button mat-stroked-button (click)="copyExport()">
        <mat-icon>content_copy</mat-icon>
        <span i18n="@@Export">Export</span>
      </button>
      <button mat-stroked-button (click)="importInput.click()" [disabled]="effectiveReadOnly">
        <mat-icon>file_upload</mat-icon>
        <span i18n="@@Import">Import</span>
      </button>
      <input #importInput type="file" accept="application/json" hidden
             (change)="$any($event.target).files[0] && $any($event.target).files[0].text().then(importJson.bind(this)); importInput.value=''"/>
      <button mat-stroked-button (click)="toggleDiff()">
        <mat-icon>compare_arrows</mat-icon>
        <span i18n="@@Diff">Diff</span>
      </button>
      <span class="rce-spacer"></span>
      <span class="rce-dirty" *ngIf="isDirty" i18n="@@Unsaved changes">Unsaved changes</span>
      <button mat-flat-button color="primary" (click)="save()"
              [disabled]="effectiveReadOnly || saving || !validation.valid || !isDirty">
        <mat-icon>save</mat-icon>
        <span i18n="@@Save">Save</span>
      </button>
    </div>

    <!-- Diff display ────────────────────────────────────────── -->
    <pre class="rce-diff" *ngIf="showDiff">{{diffText}}</pre>

    <!-- Validation banner ──────────────────────────────────── -->
    <div class="rce-validation rce-validation-error" *ngIf="!validation.valid">
      <mat-icon>error_outline</mat-icon>
      <div class="rce-validation-content">
        <strong i18n="@@Validation errors">Validation errors</strong>
        <ul>
          <li *ngFor="let e of validation.errors"><code>{{e.path}}</code> {{e.message}}</li>
        </ul>
      </div>
    </div>
    <div class="rce-validation rce-validation-warn" *ngIf="validation.valid && validation.warnings.length > 0">
      <mat-icon>info</mat-icon>
      <div class="rce-validation-content">
        <strong i18n="@@Warnings">Warnings</strong>
        <ul>
          <li *ngFor="let w of validation.warnings"><code>{{w.path}}</code> {{w.message}}</li>
        </ul>
      </div>
    </div>

    <!-- Document-level controls ─────────────────────────────
         (Preview page counts, facility peer multi-select, and the
         companion-as-peer toggle all live inside the Rates Preview
         panel below — they're co-located with the table they affect.) -->

    <!-- Scope tabs + active scope panel ───────────────────── -->
    <app-rate-scope-tabs [doc]="doc"
                         [activeScope]="activeScope"
                         [readOnly]="effectiveReadOnly"
                         (activeScopeChange)="setActiveScope($event)"
                         (docChange)="setDoc($event)">
    </app-rate-scope-tabs>

    <!-- v3 editor body — Kind-grouped propertyCharacteristic-matrix UI. -->
    <app-rate-scope-panel *ngIf="activeScope"
                          [scope]="activeScope"
                          [config]="activeConfig"
                          [doc]="doc"
                          [baselineDoc]="serverSnapshot"
                          [companionDoc]="companionDoc"
                          [companionLabel]="companionLabel"
                          [peerDocs]="peerDocs"
                          [availableFacilities]="availableFacilityChoices"
                          [selectedFacilityIds]="selectedFacilityIds"
                          [showCompanionAsPeer]="showCompanionAsPeer"
                          [isPackingConfig]="isPackingConfig"
                          [readOnly]="effectiveReadOnly"
                          [currency]="currency"
                          [validation]="validation"
                          (configChange)="setScopeConfig($event)"
                          (docPageCountsChange)="setPreviewPageCountsArray($event)"
                          (selectedFacilityIdsChange)="setSelectedFacilities($event)"
                          (showCompanionAsPeerChange)="setShowCompanionAsPeer($event)">
    </app-rate-scope-panel>

  </ng-container>

  <!-- Error ─────────────────────────────────────────────── -->
  <div class="rce-error" *ngIf="loadState === 'ERROR'">
    <mat-icon>error_outline</mat-icon>
    <span i18n="@@Failed to load the rate configuration.">Failed to load the rate configuration.</span>
  </div>
</div>

